import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IEnvironment } from "../models/interfaces/environment.interface";
import { DispatchGuide, type DispatchGuideOrderNumberType } from "../models/ost/documents/dispatch-guide.model";
import { ENVIRONMENT } from "../modules/keycloak.module";
import { HttpParamsUtil } from "../utils/http-params.util";
import { RetryHttpClient } from "./base/retryable-http.client";

@Injectable({ providedIn: "root" })
export class DocumentsService extends HttpParamsUtil {
  constructor(
    private readonly httpClient: RetryHttpClient,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {
    super();
  }

  getDispatchGuide(identifier: string | number, orderNumberType: DispatchGuideOrderNumberType = "DISPATCH"): Observable<DispatchGuide> {
    return this.httpClient.get<DispatchGuide>(
      `${this.environment.BASE_URL}${this.environment.OST["BASE"]}/${encodeURIComponent(String(identifier))}/guide?orderNumberType=${orderNumberType}`
    );
  }
}
